<template>
  <div class="page">
    <div class="page-container">
      <template v-if="!submited">
        <project-page-header ref="pageHeader" :id="projectId">
          <template v-slot:actions>
            <a-space>
              <a-button class="v-px-sm" icon="left" size="default" type="default" @click="$router.push(`../view/basic?id=${projectId}`)">返回项目详情</a-button>
            </a-space>
          </template>
        </project-page-header>
        <div class="page-title">填报项目报告</div>
        <div class="page-steps w600">
          <a-steps progress-dot class="v-mt-lg v-mb-md" size="small" :current="currentStep">
            <a-step title="提交项目报告">
              <div slot="description" style="white-space: nowrap; font-size: 12px" v-if="report.state > 0">
                <div>{{ report.submitTime ? report.submitTime.substring(0, 16) : '' }}</div>
              </div>
            </a-step>
            <a-step title="项目主管审核" />
            <a-step title="完成" />
          </a-steps>
        </div>
        <div class="panel-body">
          <div class="w1200">
            <a-form-model class="form-sm" ref="form" :label-col="{ span: 3 }" :wrapper-col="{ span: 18 }">
              <a-form-model-item :colon="false" v-if="report.checkResult === -1">
                <span slot="label"></span>
                <a-alert class="v-mb-sm no-border" type="error">
                  <div slot="message">
                    <div class="font-md text-darkblue flex items-center">
                      <a-icon type="alert" class="v-mr-xs" />
                      提交的项目报告已被驳回
                    </div>
                    <div class="flex v-mt-xs">
                      <span class="text-right text-grey">审核意见：</span>
                      <span class="col text-red" v-html="$utils.convertToHtml(report.checkOpinion)"></span>
                    </div>
                  </div>
                </a-alert>
              </a-form-model-item>
              <a-form-model-item :colon="false">
                <span slot="label">
                  <i class="required-mark">*</i>
                  报告类型
                </span>
                <a-space>
                  <a-select placeholder="选择报告类型" v-model="form.type" style="width: 300px" ref="type">
                    <a-select-option :value="1">月报</a-select-option>
                    <a-select-option :value="2">季报</a-select-option>
                    <a-select-option :value="3">年报</a-select-option>
                    <a-select-option :value="9">其他</a-select-option>
                  </a-select>
                  <a-date-picker :disabled-date="disabledDate" mode="year" placeholder="选择年份" v-model="form.year" :open="showYearPanel" ref="yearPicker" @openChange="onYearPanelOpen" format="YYYY年" value-format="YYYY" @panelChange="onYearChange" style="width: 100px" v-if="form.type && form.type != 9" />
                  <a-select placeholder="选择季度" v-model="form.quarter" style="width: 110px" ref="quarterPicker" v-if="form.type == 2">
                    <a-select-option :value="1">第一季度</a-select-option>
                    <a-select-option :value="2">第二季度</a-select-option>
                    <a-select-option :value="3">第三季度</a-select-option>
                    <a-select-option :value="4">第四季度</a-select-option>
                  </a-select>
                  <a-select placeholder="选择月份" v-model="form.month" style="width: 110px" ref="monthPicker" v-else-if="form.type == 1">
                    <a-select-option :value="1">1月</a-select-option>
                    <a-select-option :value="2">2月</a-select-option>
                    <a-select-option :value="3">3月</a-select-option>
                    <a-select-option :value="4">4月</a-select-option>
                    <a-select-option :value="5">5月</a-select-option>
                    <a-select-option :value="6">6月</a-select-option>
                    <a-select-option :value="7">7月</a-select-option>
                    <a-select-option :value="8">8月</a-select-option>
                    <a-select-option :value="9">9月</a-select-option>
                    <a-select-option :value="10">10月</a-select-option>
                    <a-select-option :value="11">11月</a-select-option>
                    <a-select-option :value="12">12月</a-select-option>
                  </a-select>
                </a-space>
              </a-form-model-item>
              <a-form-model-item :colon="false">
                <span slot="label">报告精选内容</span>
                <a-textarea :auto-size="{ minRows: 5 }" v-model="form.summary" ref="summary" placeholder="报告精选内容" style="width: 100%" />
              </a-form-model-item>
              <a-form-model-item :colon="false">
                <span slot="label">
                  <i class="required-mark">*</i>
                  报告文件
                </span>
                <div class="flex items-center">
                  <a-button icon="plus" type="indigo" size="small" @click="openUploadModal">上传附件</a-button>
                  <span class="text-grey">（可上传文档、图片或短视频，至少上传一个）</span>
                </div>
                <report-medias chosen removable :project-id="projectId" :medias="medias" @update="items => (medias = items)" v-if="medias.length"></report-medias>
              </a-form-model-item>
            </a-form-model>
            <div class="text-center v-mt-lg">
              <a-space>
                <a-button icon="check" type="indigo" key="draft" @click="handleConfirmSubmit(false)" :loading="saving">保存初稿</a-button>
                <a-button icon="arrow-right" type="primary" key="submit" @click="handleConfirmSubmit(true)" :loading="saving">提交审核</a-button>
                <a-button icon="left" type="default" key="backward" @click="$router.go(-1)">返回</a-button>
              </a-space>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <a-result status="success" title="提交成功" sub-title="您填报的项目报告已提交审核，请耐心等待审核结果。">
          <template #extra>
            <a-button key="view" type="primary" @click="$router.push(`../view?id=${projectId}`)">查看项目</a-button>
            <a-button key="back" @click="$router.go(-1)">返回</a-button>
          </template>
        </a-result>
      </template>
    </div>
    <!-- 上传弹窗 -->
    <a-modal title="上传附件" :mask-closable="false" :visible="showUploadModal" @cancel="cancelUploadModal" :width="600">
      <template slot="footer">
        <a-space>
          <a-button @click="cancelUploadModal">取消</a-button>
          <a-button type="primary" @click="handlUploadSubmit">确认</a-button>
        </a-space>
      </template>
      <a-form-model class="form-sm" ref="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }" :model="form">
        <a-form-model-item :colon="false">
          <span slot="label">
            <i class="required-mark">*</i>
            选择文件
          </span>
          <span class="text-grey">可上传文档、图片或短视频</span>
          <a-upload-dragger
            multiple
            :action="`${baseURL}/file/upload`"
            :data="{
              params: JSON.stringify({ projectId, fileBelongId: projectId, fileType: 5, fileSign: 'P01' }),
            }"
            :file-list="uploadFiles"
            :before-upload="beforeUploadFile"
            @preview="handlePreviewFile"
            @change="info => handleUploadChange(info, -1)"
            accept=".doc, .docx, .xls, .xlsx, .pdf, .ppt, .pptx, .png, .jpg, .jpeg, .gif, .mp4, .flv, .mov, .avi, .rmvb, .3gp, .wma"
            ref="uploadFiles"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="upload" />
            </p>
            <p class="ant-upload-text">点击选择或拖拽文件至此区域上传</p>
          </a-upload-dragger>
        </a-form-model-item>
        <a-form-model-item label="是否为精选" :colon="false">
          <a-switch v-model="isChoice" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import ProjectPageHeader from '../common/page-header'
import { getReport, saveReport } from '@/api/project/common'
const convertToMediaBean = (medias, mediaType) => medias.filter(d => d.files && d.files.length).map(({ isChoice, files }) => ({ isChoice: ~~isChoice, mediaType, file: { fileId: files[0].fileId } }))
export default {
  name: 'ProjectReportReview',
  components: {
    ProjectPageHeader,
  },
  data() {
    return {
      id: undefined,
      projectId: undefined,
      reportId: undefined,
      submited: false,
      currentStep: 0,
      saving: false,
      report: {},
      medias: [],
      form: {
        type: undefined,
        year: undefined,
        month: undefined,
        quarter: undefined,
        summary: '',
        fileIds: [],
      },
      fileList: [],
      uploadMediaType: 1,
      uploadFiles: [],
      showUploadModal: false,
      isChoice: false,
      showYearPanel: false,
    }
  },
  methods: {
    init() {
      let { id, rid } = this.$route.query
      if (id) {
        this.projectId = +id
      }
      if (rid) {
        this.reportId = +rid
        this.loadRecord()
      }
    },
    loadRecord() {
      this.loading = true
      getReport(this.reportId).then(({ data }) => {
        if (data.success) {
          this.report = data.result
          let { state, medias, summary, type, year, month, quarter } = data.result
          medias.forEach(item => {
            item.uid = Math.random()
            item.files = item.file ? [item.file] : []
            item.isChoice = !!item.isChoice
          })
          this.form = {
            type,
            year: year ? `${year}` : undefined,
            month,
            quarter,
            summary,
          }
          this.medias = medias
          if (state == 0 || state == -1) {
            this.currentStep = 0
          } else {
            this.currentStep = state
          }
        }
      })
    },
    disabledDate(current) {
      return current && current > this.$moment().endOf('day')
    },
    onYearChange(date) {
      this.form.year = date.format('YYYY')
      this.showYearPanel = false
    },
    onYearPanelOpen(status) {
      this.showYearPanel = status
    },
    handleConfirmSubmit(nextStep) {
      this.$message.destroy()
      let { type, year, quarter, month } = this.form
      if (!type) {
        this.$refs.type.focus()
        this.$message.warn('请选择报告类型')
        return
      }
      if (type && type != 9 && !year) {
        this.$refs.yearPicker.focus()
        this.$message.warn('请选择报告年份')
        return
      }
      if (type == 1 && !month) {
        this.$refs.monthPicker.focus()
        this.$message.warn('请选择报告月份')
        return
      }
      if (type == 2 && !quarter) {
        this.$refs.quarterPicker.focus()
        this.$message.warn('请选择报告季度')
        return
      }
      if (this.medias.length === 0 || this.medias[0].files.length === 0) {
        this.$message.warn('请上传报告文件')
        return
      }
      this.$confirm({
        title: nextStep ? '确认提交项目报告？' : '确认保存初稿？',
        centered: true,
        onOk: () => {
          this.handleSubmit(nextStep)
        },
      })
    },
    handleSubmit(nextStep) {
      let { projectId, reportId, medias } = this
      let { type, summary, year, month, quarter } = this.form
      let params = {
        reportId,
        projectId,
        type,
        year,
        month,
        quarter,
        summary: summary.trim(),
        nextStep,
        origin: 1,
        medias: convertToMediaBean(medias),
      }
      this.saving = true
      saveReport(params)
        .then(({ data }) => {
          if (data.success) {
            if (nextStep) {
              this.submited = true
            } else {
              this.reportId = data.result
              this.$message.success('操作成功')
              this.$router.push(`../view/report?id=${projectId}`)
            }
          } else {
            this.$message.warning(data.msg)
          }
          this.saving = false
        })
        .catch(err => {
          if (err) {
            this.$message.warning(err)
          }
          this.saving = false
        })
    },
    handleUploadChange(info, count) {
      this.uploadFiles = this.handleUploadFile(info, count)
      this.$refs.uploadFiles.$el.classList.remove('uploader-empty')
    },
    handleRemoveFile(index) {
      this.medias.splice(index, 1)
    },
    openUploadModal() {
      this.isChoice = false
      this.uploadFiles = []
      this.showUploadModal = true
    },
    cancelUploadModal() {
      this.showUploadModal = false
    },
    handlUploadSubmit() {
      this.$message.destroy()
      let { uploadFiles, isChoice } = this
      if (uploadFiles.length === 0) {
        this.$message.warn('请选择上传文件')
        this.$refs.uploadFiles.$el.classList.add('uploader-empty')
        return
      }
      let files = this.$utils.cloneDeep(uploadFiles)
      let medias = files.map(file => ({
        uid: Math.random(),
        isChoice,
        fileId: file.fileId,
        file,
        files: [file],
      }))
      this.medias.push(...medias)
      this.cancelUploadModal()
    },
  },
  created() {
    this.init()
  },
}
</script>
